import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Api from './services/api/api.js'

Vue.config.productionTip = false;

const $ = require('jquery');
window.$, window.jQuery = $;
window.Api = Api;


new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');


